import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import {
  Image,
  Section,
  SectionHeader,
  BoxDiscover,
  Box,
  Paragraph,
  Heading,
  BoxLayoutMobileSingle,
  BackgroundImage,
  Button,
  IconSVG,
  Link,
} from 'components';
import Clutch from 'assets/images/logos/clutch-white.svg';
import Awwwards from 'assets/images/logos/awwwards-white.svg';
import Dribbble from 'assets/images/logos/dribbble-white.svg';
import config from '../../../../../meta/config';
import './SocialMedia.scss';

const SocialMedia = () => (
  <StaticQuery
    query={graphql`
      query {
        imageBlog: file(
          relativePath: { eq: "connect/blog-september-topic-art.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        socialMediaBackground: file(
          relativePath: { eq: "connect/people-having-fun-during-meetup.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        awardsBackground: file(
          relativePath: { eq: "connect/awards-background.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 629) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section
        color={'gray-light'}
        additionalClass={'connect-page__social-media'}
      >
        <SectionHeader size={'big'} lineColor={'violet'} fixed>
          Connect and dig into
          <br />
          Digital Shift
        </SectionHeader>
        <BoxLayoutMobileSingle
          additionalClass={'connect-page__social-media-row'}
        >
          <Box additionalClass={'box-discover'}>
            <div className={'box-discover__content'}>
              <Heading color={'white'} size={'big'} type={3}>
                Social media @Boldarecom
              </Heading>
              <Paragraph
                color={'white'}
                additionalClass={'text--light box-discover__description'}
                spaced
              >
                Get a glimpse of our company culture, find out how our clients
                build successful digital products, and learn more on how to
                develop human-centered software.
              </Paragraph>
            </div>
            <LazyLoad once offset={200}>
              <BackgroundImage
                src={data.socialMediaBackground.childImageSharp.fluid}
                additionalClass={'box-discover__background'}
              />
            </LazyLoad>
            <div
              className={'box-discover__footer connect-page__social-media-box'}
            >
              <Link to={config.facebook}>
                <Button color={'white'} transparent>
                  <IconSVG
                    size={'medium'}
                    name={'facebook-letter'}
                    color={'white'}
                  />
                </Button>
              </Link>
              <Link to={config.instagram}>
                <Button color={'white'} transparent>
                  <IconSVG
                    size={'medium'}
                    name={'instagram'}
                    color={'white'}
                  />
                </Button>
              </Link>
              <Link to={config.linkedin}>
                <Button color={'white'} transparent>
                  <IconSVG
                    size={'medium'}
                    name={'linkedin-letter'}
                    color={'white'}
                  />
                </Button>
              </Link>
              <Link to={config.twitter}>
                <Button color={'white'} transparent>
                  <IconSVG size={'medium'} name={'twitter'} color={'white'} />
                </Button>
              </Link>
            </div>
          </Box>
          <BoxDiscover
            background={data.imageBlog.childImageSharp.fluid}
            link={'/blog/'}
            headline={'Boldare blog'}
            description={
              'Digital Shift - be up to date with the latest insights into digital product design and development'
            }
            backgroundColor={'white'}
            buttonText={'Discover'}
            externalLink
          />
          <Box additionalClass={'box-discover'}>
            <div className={'box-discover__content'}>
              <Heading color={'white'} size={'big'} type={3}>
                Awards &amp; rankings
              </Heading>
              <Paragraph
                color={'white'}
                additionalClass={'text--light box-discover__description'}
                spaced
              >
                Our company and digital products are internationally recognized
                for innovative approach, stellar user experience and impeccable
                code quality
              </Paragraph>
            </div>
            <LazyLoad once offset={200}>
              <BackgroundImage
                src={data.awardsBackground.childImageSharp.fluid}
                additionalClass={'box-discover__background'}
              />
            </LazyLoad>
            <div
              className={'box-discover__footer connect-page__social-media-box'}
            >
              <Link to={config.clutch}>
                <Button color={'white'} transparent>
                  <Image src={Clutch} />
                </Button>
              </Link>
              <Link to={config.dribbble}>
                <Button color={'white'} transparent>
                  <Image src={Dribbble} />
                </Button>
              </Link>
              <Link to={config.awwwards}>
                <Button color={'white'} transparent>
                  <Image src={Awwwards} />
                </Button>
              </Link>
            </div>
          </Box>
        </BoxLayoutMobileSingle>
      </Section>
    )}
  />
);

export default SocialMedia;
